import Vue from 'vue'
Vue.prototype.$availableDeliveryType = {
  tailored: [
    {
      key: 'D1',
      variant: [
        {
          key: 'devshoeended',
          variant: [
            {
              key: 'devshoeended',
            },
            {
              key: 'devshoeendedwithbatt',
            },
          ],
        },
        {
          key: 'onlytom',
          variant: [
            {
              key: 'onlytom',
            },
            {
              key: 'tomplus',
            },
          ],
        },
        { key: 'testshoes' },
        {
          key: 'onlyforme',
          variant: [
            {
              key: 'onlyforme',
            },
            {
              key: 'formplant',
              value: 'Forme e plantari',
            },
          ],
        },
      ],
    },
    {
      key: 'D2',
      variant: [
        {
          key: 'devshoeended',
          variant: [
            {
              key: 'devshoeended',
            },
            {
              key: 'devshoeendedwithbatt',
            },
          ],
        },
        { key: 'testshoes' },
      ],
    },
    {
      key: 'D3',
      variant: [
        {
          key: 'devshoeended',
          variant: [
            {
              key: 'devshoeended',
            },
          ],
        },
        {
          key: 'tryshoe',
          variant: [
            {
              key: 'trymont',
            },
            {
              key: 'trymat',
            },
            {
              key: 'tryfon',
            },
          ],
        },
      ],
    },
    {
      key: 'D4',
      variant: [
        {
          key: 'devshoeended',
          variant: [
            {
              key: 'devshoeended',
            },
            {
              key: 'devshoeendedwithbatt',
            },
          ],
        },
        {
          key: 'tryshoe',
          variant: [
            {
              key: 'trymont',
            },
            {
              key: 'trymat',
            },
            {
              key: 'tryfon',
            },
          ],
        },
        {
          key: 'onlytom',
          variant: [
            {
              key: 'onlytom',
            },
            {
              key: 'tomplus',
            },
          ],
        },
        { key: 'testshoes' },
        {
          key: 'onlyforme',
          variant: [
            {
              key: 'onlyforme',
            },
            {
              key: 'formplant',
              value: 'Forme e plantari',
            },
          ],
        },
      ],
    },
  ],
  fits: [
    {
      key: 'DF1',
      variant: [
        {
          key: 'devshoeended',
          variant: [
            {
              key: 'devshoeended',
            },
            {
              key: 'devshoeendedwithbatt',
            },
          ],
        },
        {
          key: 'tryshoe',
          variant: [
            {
              key: 'trymont',
            },
            {
              key: 'tryfon',
            },
          ],
        },
      ],
    },
    {
      key: 'DF2',
      variant: [
        {
          key: 'devshoeended',
          variant: [
            {
              key: 'devshoeended',
            },
            {
              key: 'devshoeendedwithbatt',
            },
          ],
        },
      ],
    },
  ],
  modular: [
    {
      key: 'DM1',
      variant: [
        {
          key: 'devshoeended',
          variant: [
            {
              key: 'devshoeended',
            },
          ],
        },
        {
          key: 'premount',
          variant: [
            {
              key: 'premountwithmaterial',
            },
          ],
        },
      ],
    },
  ],
  insole: [
    {
      key: 'DI1',
      variant: [
        {
          key: 'finishedplantar',
          variant: [
            {
              key: 'cover',
            },
            {
              key: 'nocover',
            },
            {
              key: 'detachedcover',
            },
          ],
        },
        {
          key: 'border_cropped',
          variant: [
            {
              key: 'nocover',
            },
            {
              key: 'detachedcover',
            },
          ],
        },
      ],
    },
  ],
}
